import { formatNumber } from 'utils/formatCurrencyAmount'
import { formatDollarAmount } from 'utils/portfolio/formatDollar'

interface TokenBalanceDisplayProps {
  amount: number
  symbol: string
  usdValue: number
  className?: string
}

interface FormattedTokenBalanceProps {
  value: string
  className?: string
}

export function TokenBalanceDisplay({ amount, symbol, usdValue, className = '' }: TokenBalanceDisplayProps) {
  return (
    <div className={`text-xs text-kodiak-text-primary flex items-center justify-end gap-1 ${className}`}>
      <span>
        {formatNumber(amount)} {symbol}
      </span>
      <span className="text-[#7B97B7]">({formatDollarAmount(usdValue)})</span>
    </div>
  )
}

export function FormattedTokenBalance({ value, className = '' }: FormattedTokenBalanceProps) {
  const parenIndex = value.indexOf('(')

  if (parenIndex === -1) {
    return <div className={className}>{value}</div>
  }

  const tokenPart = value.substring(0, parenIndex).trim()
  const usdPart = value.substring(parenIndex)

  return (
    <div className={className}>
      {tokenPart} <span className="text-[#7B97B7]">{usdPart}</span>
    </div>
  )
}
